import React from "react";
import Locations from "./Locations";
const App = () => {
  return <Locations />;
};

export default App;
